import TRANSLATE from '../resources/translate'
import PARAMETER from '../resources/parameters'
import ERROR from '../resources/error'

const translate = (key: string): string => {
    return TRANSLATE[key]
}

const parameter = (key: string): string | number => {
    return PARAMETER[key]
}

const error = (code: number): string | number => {
    return ERROR[code]
}

export { translate, parameter, error }
